import abstractModel from '../../core/ShopModel';

const resource = 'retailers/brands';

const model = abstractModel(resource);

model.getAll = () => model.get({}, { path: `${resource}/all` });

export default model;
